<div class="row media" class="fx-layout-column fx-layout-align-center-center"
  *ngIf="(currentState$ | async).currentState === 'QuizSubmitting' || (currentState$ | async).currentState === 'FinalQuizSubmitting' || (currentState$ | async).currentState === 'FinalQuizShow'">
  <mat-spinner strokeWidth="3" diameter="100"></mat-spinner>
</div>

<div class="row" *ngIf="(currentState$ | async).currentState === 'QuizLoaded'">
  <div class="fx-layout-column">
    <div class="row" id="quizForm">
      <b>{{ chapter?.ChapterName }} #{{ quiz?.QuizOrder }} of {{ quizzesPerChapter?.length }}</b>
      <h5>{{ quiz?.QuizTitle }}</h5>
      <b>Please click on the answer text to select the option</b>
      <form [formGroup]="quizForm" (ngSubmit)="submitQuiz()" *ngIf="quiz">
        <div class="fx-layout-column" *ngFor="let question of quiz.questions">
          <div class="fx-flex" formGroupName="{{ question.QuestionID }}">
            <label class="black-text">{{question.QuestionText}}</label>
            <mat-radio-group class="quiz-radio-group" formControlName="AnswerOptID">
              <label class="radio-label" *ngFor="let option of question.answerOptions; let i = index">
                <mat-radio-button class="quiz-radio-button"
                  [value]="option.AnswerOptID"
                  (click)="$event.stopPropagation()">
                  <span class="radio-content">
                    <span class="black-text wrap" *ngIf="option.AnswerType === 'TEXT'">{{ getOptionLetter(i) }}. {{ option.AnswerText }}</span>
                    <span *ngIf="option.AnswerType === 'IMAGE'">
                      <span class="black-text">{{ getOptionLetter(i) }}.</span>
                      <img width="100px" [src]="getImage(option.AnswerText)" alt="option image">
                    </span>
                  </span>
                </mat-radio-button>
              </label>
            </mat-radio-group>
          </div>
        </div>
        <button mat-raised-button color="primary" type="submit">Submit</button>
      </form>
    </div>
  </div>
</div>

<div class="row media" *ngIf="(currentState$ | async).currentState === 'QuizSkipped'">
  <div class="fx-layout-column" *ngIf="isQuizSkippingNotAllowed$ | async as state">
    <div class="row">
      <h5>Notice</h5>
      <div *ngFor="let quiz of state.incompleteQuizzes">
        <p class="red-text">Quiz Not Complete: <a [routerLink]="getIncompleteLink(quiz)">{{ quiz.QuizLocation }} - quiz
            {{ quiz.QuizOrder }} - {{ quiz.QuizTitle }}</a></p>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="(currentState$ | async).currentState === 'QuizSubmitted'">
  <div class="fx-layout-column">
    <div class="row" *ngIf="(currentState$ | async).result">
      <h5>Result</h5>
      <p>There are {{ quiz.questions.length }} questions in the quiz you submitted.</p>
      <p>Your grade is {{ currentState.result.score }}%</p>
      <p>You answered {{ quiz.questions.length - currentState.result.wrongQuestions.length }} questions correctly.</p>

      <h5>Incorrect Answers are as follows:</h5>
      <div *ngFor="let question of currentState.result.wrongQuestions">
        <p class="red-text">Question: {{ question.QuestionText }}</p>
        <p class="red-text">Answer: {{ getAnswer(question) }}</p>
      </div>
      <p>Would you like to take this quiz again? If so, <a style="cursor: pointer;" (click)="retakeQuiz()">click
          here</a></p>
    </div>
  </div>
</div>

<div class="row media" *ngIf="(currentState$ | async).currentState === 'AssetShow' && asset">
  <div class="fx-layout-column">
    <div class="row w-full md:w-[640px] h-[400px] md:h-[800px]">
      <video class="w-full h-full" controls *ngIf="asset.contentType === 'video/mp4'">
        <source [src]="getAssetUrl()" type="video/mp4">
        <!-- <source src="{{getVideo()}}.ogv" type="video/ogv"> 
        <source src="{{getVideo()}}.webm" type="video/webm"> -->
      </video>
      <pdf-viewer [src]="getAssetUrl()" [render-text]="true" [original-size]="false" class="w-full h-full"
        *ngIf="asset.contentType === 'application/pdf'">
      </pdf-viewer>

      <iframe [src]="getPptUrl()" class="w-full h-full" frameborder='0'
        *ngIf="asset.contentType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'">
      </iframe>
    </div>
  </div>
</div>

<div class="row media" *ngIf="(currentState$ | async).currentState === 'VideoShow'">
  <div class="fx-layout-column">
    <div class="row w-full md:w-[640px] h-[400px] md:h-[70vh]">
      <video class="w-full h-full" controls>
        <source src="{{getVideo()}}.mp4" type="video/mp4">
        <!-- <source src="{{getVideo()}}.ogv" type="video/ogv">
        <source src="{{getVideo()}}.webm" type="video/webm"> -->
      </video>
    </div>
  </div>
</div>

<div class="row media" *ngIf="(currentState$ | async).currentState === 'AudioShow'">
  <div class="fx-layout-column">
    <div class="row">
      <audio class="responsive-audio" controls>
        <source src="{{getSound()}}.wav" type="audio/wav">
      </audio>
    </div>
  </div>
</div>

<div class="w-full mb-4" *ngIf="(currentState$ | async).currentState === 'FinalQuizLoaded'">
  <div class="flex flex-col">
    <div class="w-full mb-4" id="finalForm" *ngIf="quiz && quiz.questions">
      <h5 class="text-red-600 font-semibold mb-4">PLEASE CLICK ON THE CORRECT ANSWER AND PRESS THE SUBMIT BUTTON AT THE COMPLETION OF THE TEST.
      </h5>
      <div class="w-full">
        <h5 class="text-xl font-bold mb-4">{{ quiz.QuizTitle }}</h5>
        <form [formGroup]="quizForm" (ngSubmit)="submitQuiz()" class="space-y-6">
          <div class="flex flex-col space-y-4" *ngFor="let question of quiz.questions">            
            <div class="flex flex-col" formGroupName="{{ question.QuestionID }}">
              <label class="text-black font-medium mb-2">{{question.QuestionText}}</label>
              <mat-radio-group class="quiz-radio-group flex flex-col space-y-2" formControlName="AnswerOptID">
                <label class="radio-label" *ngFor="let option of question.answerOptions; let i = index">
                  <mat-radio-button class="quiz-radio-button"
                    [value]="option.AnswerOptID"
                    (click)="$event.stopPropagation()">
                    <span class="radio-content text-black" *ngIf="option.AnswerType === 'TEXT'">{{ getOptionLetter(i) }}. {{ option.AnswerText }}</span>
                    <span class="radio-content" *ngIf="option.AnswerType === 'IMAGE'">
                      <span class="text-black">{{ getOptionLetter(i) }}.</span>
                      <img src="{{ getImage(option.AnswerText) }}" class="max-w-full h-auto" alt="option">
                    </span>
                  </mat-radio-button>
                </label>
              </mat-radio-group>
            </div>
          </div>
          <button mat-raised-button color="primary" type="submit" class="mt-4">Submit</button>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="w-full mb-4" *ngIf="(currentState$ | async).currentState === 'FinalQuizSubmitted'">
  <div class="flex flex-col">
    <div class="w-full mb-4" *ngIf="(currentState$ | async).result && ((currentState$ | async).result.score < 60)">
      <h5 class="text-xl font-bold mb-4">Result</h5>
      <p class="mb-2">There are {{ quiz.questions.length }} questions in the quiz you submitted.</p>
      <p class="mb-2">Your grade is {{ (currentState$ | async).result.score }}%</p>
      <p class="mb-2">You answered {{ quiz.questions.length - (currentState$ | async).result.wrongQuestions.length }} questions correctly.</p>
    </div>
    <div class="w-full mb-4" *ngIf="(currentState$ | async).result && ((currentState$ | async).result.score >= 60)">
      <h5 class="text-xl font-bold mb-4">Final Quiz Completed</h5>
      <div class="w-full">
        <button mat-raised-button color="primary" (click)="downloadCertificate()">Print Certificate</button>
      </div>
    </div>
  </div>
</div>

<div class="w-full mb-4" *ngIf="(currentState$ | async).currentState === 'FinalQuizAlreadyDone'">
  <div class="flex flex-col">
    <div class="w-full">
      <h5 class="text-xl font-bold mb-4">Notice</h5>
      <p class="text-red-600">We're sorry, but you are not allowed to take the final test right now. As you have
        completed
        final quiz</p>
    </div>
  </div>
</div>

<div class="w-full mb-4" *ngIf="(currentState$ | async).currentState === 'FinalNotAllowedQuizIncomplete'">
  <div class="flex flex-col" *ngIf="isFinalNotAllowedQuizIncomplete$ | async as state">
    <div class="w-full">
      <h5 class="text-xl font-bold mb-4">Notice</h5>
      <div class="space-y-2" *ngFor="let quiz of state.incompleteQuizzes">
        <p class="text-red-600">Quiz Not Complete: <a [routerLink]="getIncompleteLink(quiz)" class="text-blue-600 hover:underline">{{ quiz.QuizLocation }} -
            quiz
            {{ quiz.QuizID }} - {{ quiz.QuizTitle }}</a></p>
      </div>
    </div>
  </div>
</div>
